<template>
  <div class="flex flex-col gap-2 min-w-0">
    <dt
      class="text-xs font-medium uppercase tracking-wide text-neutral-text-weak"
    >
      {{ label }}
    </dt>
    <dd
      class="text-sm text-neutral-text-strong m-0"
      :class="{ 'tabular-nums': isNumeric }"
      :title="title"
    >
      <template v-for="(part, idx) in parts" :key="idx">
        <span v-if="idx > 0" class="text-neutral-text-placeholder mx-4">·</span>
        {{ part.value }}
        <span v-if="part.suffix" class="text-neutral-text-weak font-normal">
          {{ part.suffix }}
        </span>
      </template>
      <div
        v-if="subtitle"
        class="text-xs text-neutral-text-weak mt-2 truncate"
        :title="subtitle"
      >
        {{ subtitle }}
      </div>
    </dd>
  </div>
</template>

<script setup lang="ts">
type MetaPart = { value: string; suffix?: string };

defineProps<{
  label: string;
  parts: MetaPart[];
  isNumeric?: boolean;
  subtitle?: string;
  title?: string;
}>();
</script>
